import { Injectable, inject } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subscription, distinctUntilChanged, filter } from "rxjs";
import { FontLoaderService } from "./font-loader.service";

export function getFontsFromRoute(route: ActivatedRoute, lastFonts?: Array<string>): Array<string> | undefined {

    //if the title is available for the current route, it will be considered as lastAvailableTitle
    if (route.snapshot.data['cwsFonts']) {
        lastFonts = route.snapshot.data['cwsFonts'];
    }

    if (route.children.length == 0) {
        //if there are no more children, last available title will be returned
        return lastFonts;
    } else {
        for (let child of route.children) {
            //drilling down to get the last available title from the deepest child hierarchy
            const fonts = getFontsFromRoute(child, lastFonts);

            if (fonts) {
                return fonts;
            }
        }
    }

    //if there is no title, undefined will be returned
    return undefined;
}

@Injectable({
    providedIn: 'root'
})
export class CWSFontsService {
    private fontLoaderService = inject(FontLoaderService);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);


    private subscription$: Subscription = Subscription.EMPTY;

    /**
     * Returns true if this service is listening to the router in order to manage the titles
     */
    public get isMonitoring() {
        return this._isMonitoring;
    }

    private _isMonitoring = false;;

    /**
    * Starts listening to the router in order to manage the title
    */
    startMonitoring() {
        if (this._isMonitoring) {
            return;
        }
        this._isMonitoring = true;

        this.subscription$ = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            distinctUntilChanged()).subscribe(() => {
                const fonts = getFontsFromRoute(this.activatedRoute);
                
                //removeAll fonts set through font
                this.fontLoaderService.romoveAllFonts();

                if (fonts && fonts?.length > 0) {
                    fonts.forEach((font,index) => {
                        const identifier = 'font__'+index;
                        this.fontLoaderService.loadFont(identifier, font);
                    })
                   
                }

            });
    };

    /**
     * Stops listening to the router
     */
    stopMonitoring() {
        this.subscription$.unsubscribe();
        this.subscription$ = Subscription.EMPTY;
        this._isMonitoring = false;
    };

    public ngOnDestroy() {
        this.stopMonitoring();
    };
}